import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/system';
import Image from 'next/image';
import { useSelector } from '@/app/store';
import { getBaseURL } from '@/app/global-functions/baseURLUtils-administrators';
import { getBaseURL as getProfessorBaseURL } from '@/app/global-functions/baseURLUtils-professors';
import { getBaseURL as getStudentBaseURL } from '@/app/global-functions/baseURLUtils-studens';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

const UtilisateurImageComponent = () => {
  const theme = useTheme();
  const [userImage, setUserImage] = useState("");
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

  const fallbackImage = "/images/default-user.png"; // Default fallback image

  const [openImage, setOpenImage] = useState(false);

  useEffect(() => {
    const fetchImage = async () => {
      if (paramMemoire?.length > 0) {
        const item = paramMemoire[0]; // Assuming the first item in the array is the relevant one

        getImageAsBase64();

// setoutroCampo3
       /*  let imageUrl = fallbackImage; // Default fallback
        if (Number(item.typeUtilisateur) === 1) {
          imageUrl = `${getBaseURL()}/users/images?tipoDisplay=${item.photofilename || "semfoto.png"}&typeUtilisateur=${item.typeUtilisateur}`;
     
          console.log("image22222#####  ", imageUrl);

        } else if (Number(item.typeUtilisateur) === 2) {
          imageUrl = `${getProfessorBaseURL()}/users/images?tipoDisplay=${item.photofilename || "semfoto.png"}&typeUtilisateur=${item.typeUtilisateur}`;
        } else if (Number(item.typeUtilisateur) === 3) {
          imageUrl = `${getStudentBaseURL()}/users/images?tipoDisplay=${item.photofilename || "semfoto.png"}&typeUtilisateur=${item.typeUtilisateur}`;
        } */

       /*  try {
          const base64Image = await getImageAsBase64(imageUrl);

          setUserImage(base64Image); // Set the base64 image as the user image
        } catch (error) {
          console.error("Error fetching the image as Base64:", error);
          setUserImage(fallbackImage); // Fallback to default image in case of an error
        } */
      }
    };

    fetchImage();
  }, [paramMemoire]);

  
  
  async function getImageAsBase64() {
    // Correctly retrieve the value using the exact key
    const storedImageLocally = localStorage.getItem('storedIUsermage'); // Notice the exact case
  //   console.log("Stored Image Locally:", storedImageLocally);
  
    if (storedImageLocally && storedImageLocally.startsWith('data:image/')) {
   //    console.log("Valid Base64 Image Found");
      setUserImage(storedImageLocally);
    } else {
       console.error('Stored image is not in valid base64 format or is missing');
    }
  }
  
  // Display Image in an <img> tag
  async function displayImage(imageUrl) {
    try {
      const base64Image = await getImageAsBase64(imageUrl);
      document.getElementById('imageElement').src = base64Image;
    } catch (error) {
      console.error('Error displaying image:', error);
    }
  }

  const handleImageClick = () => {
    setOpenImage(true);
  };
  
  const handleClose = () => {
    setOpenImage(false);
  };

  
  return (
    <>
    <Box
      sx={{
        position: "relative",
        width: 140,
        height: 140,
        mt: -2,
        cursor: "pointer",
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Image
        src={userImage || fallbackImage}
        alt="User Avatar"
        layout="fill"
        objectFit="cover" // Ensures proportional image fit
        priority // Preload for performance
        onError={() => setUserImage(fallbackImage)} // Handles broken image URLs
        onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling
          handleImageClick();
        }} 
      />
    </Box>

{/* Dialog for Enlarged Image */}
<Dialog open={openImage} onClose={handleClose} maxWidth="md">
  <DialogTitle>
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Image
        src={userImage || fallbackImage}
        width={380} // Adjust size as needed
        height={300}
        unoptimized
        style={{
          borderRadius: "10px",
          maxWidth: "100%",
          maxHeight: "100%",
        }}
        alt="Enlarged Profile"
      />
    </Box>
  </DialogContent>
</Dialog>

    </>
  );
};

export default UtilisateurImageComponent;

//image_icon_payByMobileMoney_eng